/*
 * @Author: your name
 * @Date: 2020-12-21 19:20:44
 * @LastEditTime: 2021-01-11 16:21:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /fe-yanjiusheng-h5/src/components/Link/index.js
 */
/*global GLOBAL_BRIDGE */

import React from 'react';
import './index.scss';
import { PAGES_MAP, LINKS_MAP } from '../../constrants/types';
import Tools from '../../util/tools';

const { createQueryStringByParams, getQuery, GET, checkIsLogin } = Tools;
const APP_ID = GET.app_id || 100000;

const isOnSiteLink = (url) => {
  return url.indexOf('./') >= 0 ? true : false;
}

const producePageLink = ({ href, link_page_id, link_page_param = {}, link_type, link_page_type }) => {
  let url = '';
  let query = '';

  // 站内链接，已加app_id 或者 站外链
  // 都直接使用已有url
  if (href.length > 0 && (isOnSiteLink(href) && href.indexOf('app_id') > 0 || !isOnSiteLink(href))) {
    url = href;
  }
  // 如果有page_id，跳转相应页面
  else if (link_page_id && PAGES_MAP[link_page_type]) {
    link_page_param.page_id = link_page_id;
    query = createQueryStringByParams(link_page_param);
    url = `${PAGES_MAP[link_page_type]['url']}?app_id=${APP_ID}${query ? ("&" + query) : ""}`;
  }
  // 站内链接，未加app_id
  else if (isOnSiteLink(href)) {
    const getParams = getQuery(href);
    getParams.app_id = APP_ID;
    Object.assign(link_page_param, getParams || {})
    query = createQueryStringByParams(link_page_param);
    url = href.split('?')[0] + "?" + query;
  }
  if(link_page_param.platform || GET.platform) {
    url = `${ url }&platform=${ link_page_param.platform || GET.platform }`
  }
  return url;
}


const jump = (params, isNewOpen) => {
  if (params.link_type === 1) { // 如果跳转原生
    window.GLOBAL_BRIDGE.openNative(params.href, params.link_page_param || {});
    return false;
  }
  if (params.check_login) { // 如果需要检查登录
    if (!checkIsLogin()) return window.location.href = `./login.html?redirect=${encodeURIComponent(window.location.href)}`
  }
  const url = producePageLink(params);
  console.log('jump:', params);
  if (!url) {
    return;
  }
  if (isNewOpen) {
    window.open(url);
  } else {
    window.location.href = url;
  }
}
/* 
link_type  2：h5跳转   1：跳转App
*/
const Link = ({ children, className, link_type = 2, link_page_type, link_page_id, link_page_param = {}, check_login = false, href = "", ...props }) => {
  let onClick;
  let isNewOpen = false;
  if (props.onClick) {
    onClick = props.onClick;
  } else {
    if (props['target'] === '_blank') {
      isNewOpen = true;
    }

    if (typeof link_page_param === 'string') {
      link_page_param = {};
    }

    onClick = () => {
      jump({ href, link_type, link_page_id, link_page_type, link_page_param, check_login }, isNewOpen);
    }
  }
  return (<span className={`com-link ${className ? className : ''}`} onClick={onClick} >{children}</span>)
}

export default Link;